import { CSSProperties } from "@mui/material/styles/createTypography";
import { BlockHeadingComponent } from "./BlockHeadingComponent";
import React from "react";
import { ChartOrMessage } from "./ChartOrMessage";
import { DashPaper } from "./DashPaper";
import { SubHeading } from "./SubHeading";

interface IDashChart {
    chartKey: string;
    children?: React.ReactNode;
    heading?: string;
    subheading?: string;
    breadcrumb?: React.ReactNode;
    style: CSSProperties;
}

export function DashChart(props: IDashChart): JSX.Element {
    const { children, style, heading, subheading, breadcrumb, chartKey } = props;
    
    return (
        <DashPaper paperKey={chartKey} style={style} >
            <div >
                <BlockHeadingComponent label={heading} />
                <SubHeading text={subheading} />
                {breadcrumb}
                <ChartOrMessage show={children != null}>
                    {children}
                </ChartOrMessage>
            </div>
        </DashPaper>
    );
}
